import QRCode from 'qrcode'
import logoImgUrl from '../assets/images/logo.png'

async function renderQrCode({ text, width }) {
  const codeCanvas = await QRCode.toCanvas(text, { margin: 1, width: width })
  const logoImg = new Image()
  logoImg.src = logoImgUrl
  await loadImg(logoImg)
  const ctx = codeCanvas.getContext('2d')
  const logoW = width * 0.3
  const logo_x = (width - logoW) / 2
  const logo_y = (width - logoW) / 2
  ctx.drawImage(logoImg, logo_x, logo_y, logoW, logoW)
  return codeCanvas.toDataURL('image/jpeg', 1.0)
}
function loadImg(img) {
  return new Promise(resolve => {
    img.onload = () => {
      resolve(true)
    }
  })
}

export default renderQrCode
